import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import Table from "./Table";
import {
  getCvs,
  getSpecificCv,
  setSpecificCv,
} from "~/store/ducks/cvManagement/actionTypes";
import { Card, Badge } from "react-bootstrap";
import ModalUpload from "./ModalUpload";
import CreateActionColumn from "../CreateActionColumn";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const CV = ({ t }) => {
  const dispatch = useDispatch();
  const [cvData, setCvData] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);
  const [rowSelectedCV, setRowSelectedCV] = useState({});
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768 && configuration && configuration.mobileReady
  );

  const { cvAllList, cvDataSelected } = useSelector(
    (state) => state.cvManagementReducer
  );
  const { configuration } = useSelector((state) => state.adminConfigReducer);

  useEffect(() => {
    const interval = setInterval(() => {
      if (Object.keys(rowSelectedCV).length === 0) dispatch(getCvs());
    }, 210000);

    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    setIsMobile(
      window.innerWidth < 768 && configuration && configuration.mobileReady
    );
  }, [configuration]);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(
        window.innerWidth < 768 && configuration && configuration.mobileReady
      );
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    handleCloseModals();
    dispatch(setSpecificCv({}));
    setRowSelectedCV({});
    dispatch(getCvs());
  }, []);

  useEffect(() => {
    setCvData([...cvAllList].reverse());
  }, [cvAllList]);

  useEffect(() => {
    if (Object.keys(cvDataSelected).length > 0) {
      setRowSelectedCV(cvDataSelected);
      setUploadModal(true);
    } else {
      setRowSelectedCV({});
      setUploadModal(false);
    }
  }, [cvDataSelected]);

  const selectRow = (row) => {
    if (row) {
      dispatch(getSpecificCv(row.id));
    }
  };

  const buildActionsColumn = (_, row, _rowIndex, formatExtraData) => (
    <CreateActionColumn select={selectRow} row={row} />
  );

  const combinedActionsFormatter = (cell, row, rowIndex, formatExtraData) => {
    const actions = buildActionsColumn(cell, row, rowIndex, formatExtraData);

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ marginTop: "2rem" }}>{actions}</div>
      </div>
    );
  };

  const checkFormatter = (cell) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {cell ? (
          <FaCheckCircle style={{ color: "green", marginLeft: "10px" }} />
        ) : (
          <FaTimesCircle style={{ color: "red", marginLeft: "10px" }} />
        )}
      </div>
    );
  };

  const stateFormatter = (cell, row) => {
    let stateText = "";
    let variant = "secondary"; // cinza por padrão
    switch (cell) {
      case "PENDING":
        stateText = "Pendente";
        variant = "warning"; // cinza
        break;
      case "EXTRACTED":
        stateText = "Extraído";
        variant = "success"; // laranja
        break;
      case "FAILED":
        stateText = "Falhado";
        variant = "danger"; // vermelho
        break;
      default:
        stateText = "";
        variant = "";
    }

    return (
      <Badge pill variant={variant}>
        {stateText}
      </Badge>
    );
  };

  const columns = [
    {
      dataField: "id",
      text: "id",
      sort: false,
      hidden: true,
    },
    {
      dataField: "nome",
      text: "Nome",
      sort: true,
      style: { alignContent: "center" },
    },
    {
      dataField: "dominio",
      text: "Domínio",
      sort: true,
      style: { alignContent: "center" },
    },
    {
      dataField: "anosExperiencia",
      text: "Anos Experiência",
      sort: true,
      headerStyle: { width: "155px", textAlign: "center" },
      style: { textAlign: "center", alignContent: "center" },
    },
    {
      dataField: "grauAcademico",
      text: "Grau Académico",
      sort: true,
      headerStyle: { width: "300px" },
      style: { alignContent: "center" },
    },
    {
      dataField: "expInternacional",
      text: "Experiência Internacional",
      sort: true,
      headerStyle: { width: "220px", textAlign: "center" },
      style: { textAlign: "center" },
      formatter: checkFormatter,
      style: { alignContent: "center" },
    },
    {
      dataField: "expProjFinanciados",
      text: "Experiência Proj. Financiados",
      sort: true,
      headerStyle: { width: "240px", textAlign: "center" },
      style: { textAlign: "center" },
      formatter: checkFormatter,
      style: { alignContent: "center" },
    },
    {
      dataField: "linguas",
      text: "Linguas",
      sort: true,
      headerStyle: { width: "400px" },
      style: { alignContent: "center" },
    },
    {
      dataField: "estado",
      text: "Estado",
      sort: true,
      headerStyle: { width: "100px" },
      formatter: stateFormatter,
      style: { alignContent: "center" },
    },
    {
      dataField: "actions",
      text: "",
      sort: false,
      headerStyle: { width: "55px" },
      formatter: isMobile ? combinedActionsFormatter : buildActionsColumn,
      style: { alignContent: "center" },
    },
  ];

  const handleCloseModals = () => {
    setUploadModal(false);
  };

  return (
    <>
      <ModalUpload
        show={uploadModal}
        onClose={handleCloseModals}
        isMobile={isMobile}
        rowSelectedCV={rowSelectedCV}
        cvDataList={cvData}
      />
      <div className="main-card-v2" style={{ height: "fit-content" }}>
        <Card bsPrefix="card-flat">
          <Card.Header className="justify-content-between">
            <h6>CV's</h6>
          </Card.Header>
          <Card.Body>
            <Table
              columns={columns}
              dataList={cvData}
              setUploadModal={setUploadModal}
            />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default withNamespaces()(CV);
